import React from 'react';
import { Sparkles } from 'lucide-react';

/**
 * ChallengeInterpretation
 * Displays the "Childhood Code / Challenge" interpretation for the user
 * based on their KD1 (И — main value) and optional add value (digit-sum).
 */
const ChallengeInterpretation = ({ challenges, sectionTitle, kd1Value, kd1Add, language, enabled }) => {
  if (!enabled) return null;
  if (!challenges || !Array.isArray(challenges) || challenges.length === 0) return null;

  const lang = language && ['az', 'en', 'tr', 'ru'].includes(language) ? language : 'az';
  const sectionLabel =
    (sectionTitle && sectionTitle[lang]) ||
    (sectionTitle && sectionTitle.az) ||
    'Uşaqlıq Kodu';

  const findCh = (n) => {
    if (!n || n < 1 || n > 22) return null;
    return challenges.find((c) => Number(c.n) === Number(n)) || null;
  };

  const main = findCh(kd1Value);
  const add = findCh(kd1Add);
  const hasMain = !!main;
  const hasAdd = !!add && Number(kd1Add) !== Number(kd1Value);

  if (!hasMain && !hasAdd) return null;

  const renderCard = (ch, badgeLabel) => {
    const title = (ch.title && (ch.title[lang] || ch.title.az || ch.title.tr)) || '';
    const text = (ch.text && (ch.text[lang] || ch.text.az || ch.text.tr)) || '';
    return (
      <div key={`ch-${ch.n}-${badgeLabel}`} className="challenge-card" data-testid={`challenge-interpretation-${badgeLabel}`}>
        <div className="challenge-header">
          <div className="challenge-icon" aria-hidden>
            <Sparkles size={18} />
          </div>
          <div className="challenge-header-text">
            <div className="challenge-section-label">
              {sectionLabel}
              <span className="challenge-kind-badge" data-testid={`challenge-kind-${badgeLabel}`}>{badgeLabel}</span>
            </div>
            <h3 className="challenge-title" data-testid={`challenge-title-${badgeLabel}`}>
              Challenge {ch.n}: {title}
            </h3>
          </div>
        </div>
        <div className="challenge-body" data-testid={`challenge-body-${badgeLabel}`}>
          {text}
        </div>
      </div>
    );
  };

  const mainBadge = lang === 'tr' ? 'Ana' : lang === 'en' ? 'Main' : lang === 'ru' ? 'Основной' : 'Əsas';
  const addBadge = lang === 'tr' ? 'Yardımcı' : lang === 'en' ? 'Secondary' : lang === 'ru' ? 'Дополнительный' : 'Köməkçi';

  return (
    <>
      {hasMain && renderCard(main, mainBadge)}
      {hasAdd && renderCard(add, addBadge)}
    </>
  );
};

export default ChallengeInterpretation;
